import type { ReactNode } from "react";

/**
 * The web adapter for T3 Code's AppSidebarLayout.
 *
 * The outer composition is intentionally the same as T3's: a full-height
 * sidebar owns its chrome and navigation, while the workspace is a separate
 * flex column. Comet only supplies the route body and keeps its existing store
 * actions at the edges of the layout.
 */
export function AppSidebarLayout({
  sidebar,
  children,
  sidebarHidden = false
}: {
  sidebar: ReactNode;
  children: ReactNode;
  sidebarHidden?: boolean;
}) {
  return (
    <div className="flex h-dvh min-h-0 overflow-hidden bg-background" data-app-sidebar-layout>
      <div
        className={`${sidebarHidden ? "hidden" : "flex"} min-h-0 shrink-0 md:flex`}
        data-app-sidebar="true"
        role="navigation"
        aria-label="Threads"
      >
        {sidebar}
      </div>
      <main className="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-background">
        {children}
      </main>
    </div>
  );
}
